// Core
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import Slider from 'react-slick';
import { Box, Text, Button, useColorMode, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Assets
import { apiService } from 'services/ApiService';

// Components
import Card from 'components/Card/Card';
import { ReviewsIcon, LeftIcon, RightIcon } from 'components/Icons/Icons';
//import { reviewsList } from './DataList';

const NextArrow = ({ onClick }) => (
    <Button
    	variant="solid-lg"
        onClick={onClick}
        position="absolute"
        right={{base: '-35px', md: '30%'}}
        top="50%"
        w="64px"
        mt="-30px"
        transform="translateY(-50%)"
        zIndex="1"
        borderRadius="full"
        _hover={{ bg: '#2ABDFD' }}
    >
    	<RightIcon fontSize="24px" />   
    </Button>
);

const PrevArrow = ({ onClick }) => (
    <Button
    	variant="solid-lg"
        onClick={onClick}
        position="absolute"
        left={{base: '-35px', md: '30%'}}
        top="50%"
        mt="-30px"
        w="64px"
        transform="translateY(-50%)"
        zIndex="1"
        borderRadius="full"
        _hover={{ bg: '#2ABDFD' }}
    >
        <LeftIcon fontSize="24px" />
    </Button>
);

const ReviewsSlider = () => {
	const lineBg = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 56.18%, #FFF 68.16%, #38A9E1 82.69%, rgba(56, 169, 225, 0.00) 100%)';
    const lineBgWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
    const colorLineBg = useColorModeValue(lineBgWhite, lineBg);

    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const { data: reviewsList, isLoading } = useQuery({
        queryKey: ['testimonials'],
        queryFn: async () => {
            const response = await apiService.getTestimonials();
            return response.data;
        },
        refetchOnWindowFocus: false
    });

    const [currentSlide, setCurrentSlide] = useState(0);
    const settings = {
        dots: false, 
        infinite: true,
        speed: 500,
        slidesToShow: 3, 
        slidesToScroll: 1,
        centerMode: true, 
        centerPadding: '0%',
        beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    const responsiveSettings = useBreakpointValue({
        base: {...settings, slidesToShow: 1}, 
        md: settings 
    });

    return (
        <>
        { isLoading ? ( 
                <Box textAlign="center" mt="50px">Load clients reviews...</Box>
        ) : (
            <Box 
              position="relative"
              left="50%"
              transform="translateX(-50%)"
              width={{base: '100%', sm: '90vw', md: '120vw'}}
              zIndex="1"
              overflow="visible"
              mt="32px"
              py="28px"
              whiteSpace="nowrap">
                <Slider {...responsiveSettings}>
                    {reviewsList.map((card, index) => (
                        <Box
                            key={card.id}
                            borderRadius="16px"
                            transform={index === currentSlide ? 'scale(1.2)' : 'scale(1)'}
                            transition="transform 0.3s ease"
                            px="34px"
                            opacity={index === currentSlide ? '1' : '0.64'}
                        >
                        	<Card padding="20px 24px 24px 24px" overflow="hidden">
                        		{ index === currentSlide && (
                        			<Box 
                                        zIndex="1" 
                                        bg="#099BFF" 
                                        filter={isDark ? 'blur(36px)' : 'unset'} 
                                        w={ isDark ? '150%' : '100%' } 
                                        h={ isDark ? '160px' : '100%' } 
                                        position="absolute" 
                                        top={ isDark ? '-40px' : '0' }  
                                        left={ isDark ? '-25%' : '0' }  
                                        />
                        		)}
                        		<ReviewsIcon fontSize="28px" style={{zIndex: '2'}} color={index !== currentSlide && !isDark ? '#0E1633' : 'white'} />
    	                        <Text 
                                    color={ index === currentSlide ? 'white' : 'revert-layer' } 
                                    zIndex="2" mt="4px" mb="40px" whiteSpace="normal">{card.description}</Text>

    	                        <Box zIndex="2" />
                                <Box zIndex="2" position="relative" w="100%" m="7px 0 8px 0">
                                    <Box bg={colorLineBg} w="100%" h="2px" transform="rotate(180deg)" />
                                    { isDark && <Box bg="#099BFF" filter="blur(38px)" w="100%" h="16px" position="absolute" />}
                                </Box>
    	                        <Text zIndex="2" mt="8px" variant="header" fontSize="24px" fontStyle="normal" style={ !isDark && index === currentSlide ? {color: 'white'} : {}}>{card.title}</Text>
    	                        <Text zIndex="2" mt="4px" fontSize="20px" fontWeight="500" color="#9FABCB" style={ !isDark && index === currentSlide ? {color: 'white'} : {}}>{card.subtitle}</Text>
                            </Card>
                        </Box>
                    ))}
                </Slider>
            </Box>
        )}
        </>
    );
};

export default ReviewsSlider;
